<div class="contenitore" *ngIf="!showReward">
  <div class="contenitore_titolo">Giornata della creatività e dell'innovazione</div>

  <app-scratch-card
    imgStart="/assets/img/idea_1.jpg"
    imgEnd="/assets/img/idea_2.jpg"
    (showReward)="showReward = true"
    [percentage]="60"
  ></app-scratch-card>

  <div class="contenitore_descrizione">
    Scorri con il dito sopra la lampadina per accendere la luce creativa dell’innovazione!
  </div>
</div>

<!-- ATTENZIONE - Mostrare questo contenuto dopo aver grattato la superficie -->
<app-reward *ngIf="showReward"></app-reward>
